import React, { useEffect, useRef } from "react";
import "./styles.scss";
import { withRouter } from "react-router-dom/cjs/react-router-dom.min";

const Index = (props) => {
  const adRef = useRef(null);

  useEffect(() => {
    // create <script>
    const script = document.createElement("script");
    script.type = "text/javascript";
    script.src =
      "//pl27624615.revenuecpmgate.com/8b/9a/97/8b9a97c289b1c7b473ca8dd3d74c33c0.js";
    script.async = true;

    if (adRef.current) {
      adRef.current.innerHTML = ""; // clear old ads if re-rendered
      adRef.current.appendChild(script);
    }

    return () => {
      if (adRef.current) {
        adRef.current.innerHTML = ""; // cleanup when unmounted
      }
    };
  }, []);

  return <div ref={adRef} />;
};
export default withRouter(Index);
